/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function() {
  // Add custom code below this line
  
document.addEventListener('DOMContentLoaded', function() {
    const radioButtons = document.querySelectorAll('.radio__button');
    radioButtons.forEach(radioButton => {
        radioButton.addEventListener('click', function() {
                const inputField = this.querySelector('input');
				const submitButtons = document.querySelector('.product__submit__buttons'); 
                if (inputField) {
                    const inputValue = inputField.value;
                    const element = document.getElementById("prod-" + inputValue);
                    if (element) {
                        const dataPolicy = element.getAttribute('data-policy');
                        const dataQty = element.getAttribute('data-qty');
                        const deliveryestimation = document.querySelector('.deliveryestimation');
                        if (deliveryestimation) {
                            if ((parseInt(dataQty) > 0)) {
								if (submitButtons) { 
								submitButtons.style.display = 'grid';
								deliveryestimation.textContent = window.location.href.indexOf("/en") > -1 ? "the product will be shipped within 24/48h" : "il prodotto verrà spedito entro 24/48h"
								}
                            } else {
                                if ((dataPolicy == "continue")) {if (submitButtons) { 
								submitButtons.style.display = 'grid';
									deliveryestimation.textContent = window.location.href.indexOf("/en") > -1 ? "the product will be shipped within 12 working days" : "il prodotto verrà spedito entro 12 giorni lavorativi"
                                }}
                                if ((dataPolicy == "deny")) {
									console.log("block");
									if (submitButtons) { 
									submitButtons.style.display = 'none'; 
									deliveryestimation.textContent = window.location.href.indexOf("/en") > -1 ? "size sold out" : "taglia esaurita"} else { console.log('Element with class product__submit__buttons not found.'); 
									}
									
                                    
								}	 
                                
                            }
                        } else {
                            console.log(`Element with class name ${className} not found.`);
                        }
                    }
            } else {
                console.log(`Element with ID not found.`);
            }
       });
    });
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
